import { Locales } from "@amzn/xb-hooks";
import { Config } from "../hooks/useConfig";

/**
 * This provides values for config values that are not defined inside of
 * the Config provided by the XB Application. Values provided in this config
 * should satisfy one of the following:
 * 1. A sensible default that will enable minimal functionality of the consumer
 * 2. A value that enables the consumer to render without any special handling of
 *   null or undefined values. ({@see https://en.wikipedia.org/wiki/Null_object_pattern}
 *   for more details).
 */
export const fallbackConfig: Config = {
  xbAppName: "XbApp",
  apolloAppUri: "",
  evaluateFeatureByProxyEndpoint: "https://us-east-1.beta.exp.monitoring.skillbuilder.training.aws.dev/",
  supportedLocales: [Locales.ENGLISH],
  additionalCookies: {},
  shortbread: {
    // These are common allowed cookie domains for T&C and development
    allowedCookieDomains: [".skillbuilder.aws", ".aws.dev", "localhost"],
  },
};
